<template>
  <v-card class="mx-auto ma-2" max-width="400" min-width="300">
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline">Payments</v-list-item-title>
        <v-list-item-subtitle class="display-3 mt-5">{{ summary.payments.pI + summary.payments.pT + summary.payments.pR + summary.payments.nPI + summary.payments.nPT + summary.payments.nPR }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
        <thead>
            <tr>
            <th class="text-left"></th>
            <th class="text-left">Payed</th>
            <th class="text-left">Not payed</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Individual</td>
                <td>{{ summary.payments.pI }}</td>
                <td>{{ summary.payments.nPI }}</td>
            </tr>
            <tr>
                <td>Tandem</td>
                <td>{{ summary.payments.pT }}</td>
                <td>{{ summary.payments.nPT }}</td>
            </tr>
            <tr>
                <td>Relay</td>
                <td>{{ summary.payments.pR }}</td>
                <td>{{ summary.payments.nPR }}</td>
            </tr>
            <tr>
                <td>Total</td>
                <td>{{ summary.payments.pI + summary.payments.pT + summary.payments.pR }}</td>
                <td>{{ summary.payments.nPI + summary.payments.nPT + summary.payments.nPR }}</td>
            </tr>
        </tbody>
        </template>
    </v-simple-table>
    </v-card-text>

    <v-divider></v-divider>

  </v-card>
</template>

<script>
  export default {
    name: 'FCCCompetitionDetails',
    props: {
      summary: Object,
      reload: Function
    },
  }
</script>